<template>
	<div v-if="!isEmpty(installable)">
		<div v-if="!hidePendingInstall" class="pending-title">Pending installation</div>
		<div class="title-card width-100 display-flex flex-row flex-align-center pl-2">
			<div class="icons-card flex-centerize flex-row height-100">
				<SIcon v-if="workflowTypeIconName" width="18" :height="22" :name="workflowTypeIconName" />
				<SIcon v-if="integrationIconName" width="22" :height="22" :name="integrationIconName" class="ml-1" />
			</div>
			<div class="display-flex flex-column ml-2">
				<div class="feature-title">{{ installableTitle }}</div>
				<div class="feature-description">{{ installableDescription }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import { mapActions, mapGetters } from 'vuex';
import { getInstallable } from '@/store/modules/installables/getters';
import { getInstallable as getInstallableAction } from '@/store/modules/installables/actions';
import { FlowType } from '@ply-io/ply-front-shared-utilities';

export default {
	name: 'InstallablePreview',
	props: {
		hidePendingInstall: { type: Boolean },
		installableId: { type: String },
	},
	components: {},
	computed: {
		...mapGetters([getInstallable.fullPath]),
		installable() {
			return this[getInstallable.fullPath](this.localInstallableId) || {};
		},
		installableTitle() {
			return this.installable.title;
		},
		installableDescription() {
			if (this.installable.workflow_type === FlowType.Experience) {
				return 'Button add-on in ' + this.installable.feature_context_service.service_name;
			} else {
				return this.installable.workflow_type;
			}
		},
		workflowTypeIconName() {
			const workflowType = this.installable.workflow_type;
			if (workflowType === FlowType.Experience) {
				return 'button-installation';
			} else if (workflowType === FlowType.Tool) {
				return 'tool-installation';
			}
			return null;
		},
		integrationIconName() {
			return this.installable.feature_context_service?.service_slug;
		},
		installableIdFromRoute() {
			const returnToQuery = this.$route.query?.return_to || '';
			const returnToArr = returnToQuery.split('/');
			return returnToArr.slice(-2)[0];
		},
	},
	methods: {
		...mapActions([getInstallableAction.fullPath]),
		isEmpty(value) {
			return isEmpty(value);
		},
	},
	async mounted() {
		this.localInstallableId = this.installableId || this.installableIdFromRoute;
		await this[getInstallableAction.fullPath]({ id: this.localInstallableId });
	},
	data() {
		return {
			localInstallableId: null,
		};
	},
};
</script>

<style scoped lang="scss">
.pending-title {
	font-size: 10px;
	color: #757575;
}
.title-card {
	height: 60px;
	padding: 12px 8px;
	border-radius: 10px;
	border: 1px solid #e4e9f2;
	background: var(--bg-color);
	.icons-card {
		width: 68px;
		border-radius: 9px;
		background: var(--bg-color);
		border: 1px solid #abb2bd6e;
		box-shadow: 0px 1px 2px #80899c4d;
	}
	.feature-title {
		font-size: 14px;
		font-weight: 600;
		color: var(--primary-font-color);
	}
	.feature-description {
		font-size: 10px;
		color: #757575;
		font-weight: normal;
		text-transform: capitalize;
	}
}
</style>
